import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import withStyles from "@mui/styles/withStyles";
import Autocomplete from "@mui/material/Autocomplete";
import React, { useState, useEffect, Fragment } from "react";
import styles from "./styles";
import moment from "moment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { getTranslation } from "../../../locales";
// import TimezoneSwitch from "../TimeRangePicker/TimezoneSwitch";

const compareTime24 = (time, before, after, twentyFourHour) => {
  var startTime = before + ":00"; // for seconds
  var endTime = after + ":00"; // for seconds
  let currentTime;
  if (!twentyFourHour) {
    currentTime = moment(time, "hh:mm A").format("HH:mm");
    currentTime = currentTime + ":00"; // for seconds
  } else {
    currentTime = time + ":00"; // for seconds
  }

  let currentDate = new Date();
  let currDate = new Date(currentDate.getTime());

  currDate.setHours(currentTime.split(":")[0]);
  currDate.setMinutes(currentTime.split(":")[1]);
  currDate.setSeconds(currentTime.split(":")[2]);

  let startDate = new Date(currentDate.getTime());
  startDate.setHours(startTime.split(":")[0]);
  startDate.setMinutes(startTime.split(":")[1]);
  startDate.setSeconds(startTime.split(":")[2]);

  let endDate = new Date(currentDate.getTime());
  endDate.setHours(endTime.split(":")[0]);
  endDate.setMinutes(endTime.split(":")[1]);
  endDate.setSeconds(endTime.split(":")[2]);

  let valid = startDate <= currDate && endDate >= currDate;
  return valid;
};

function TimeRangeDropdown({
  classes,
  twentyFourHour,
  handleChangeTime,
  showRange,
  timeValue,
  currentLang,
}) {
  const [menuList, setMenuList] = useState([]);
  const [parsedTime, setParsedTime] = useState(null);
  useEffect(() => {
    // function to get all the timestamps
    const timelineLabels = (desiredStartTime, interval, period, formatTime) => {
      const periodsInADay = moment.duration(1, "day").as(period);
      const timeLabels = [];
      const startTimeMoment = moment(desiredStartTime, formatTime);
      for (let i = 0; i <= periodsInADay; i += interval) {
        startTimeMoment.add(i === 0 ? 0 : interval, period);
        timeLabels.push(startTimeMoment.format(formatTime));
      }
      return timeLabels;
    };

    let timeLabelList = !twentyFourHour
      ? timelineLabels("00:00", 15, "m", "hh:mmA")
      : timelineLabels("00:00", 15, "m", "HH:mm");

    let uniqueTimeValues = [...new Set(timeLabelList)]; // filter out unique values

    // if custom time range is specified
    if (showRange && showRange.length === 2) {
      let filteredList = uniqueTimeValues.filter((ele) => {
        return compareTime24(ele, showRange[0], showRange[1], twentyFourHour);
      });

      setMenuList(filteredList);
    } else {
      setMenuList(uniqueTimeValues);
    }
  }, [twentyFourHour]);

  const parseTimeHandler = (e) => {
    const time = e.target.value;
    if (time.length >= 2 && time.indexOf(":") === -1) {
      setParsedTime(time.substring(0, 2) + ":" + time.substring(2));
    } else setParsedTime(time);
  };

  return (
    <div className={classes.timeRangeContainer}>
      <Autocomplete
        data-testid="time"
        value={timeValue ? timeValue : parsedTime}
        onChange={handleChangeTime}
        id="time"
        options={menuList}
        getOptionLabel={(option) => option}
        className={classes.timeInputStyle}
        renderInput={(params) => (
          <TextField
            placeholder={twentyFourHour ? "HH:MM" : "HH:mm A"}
            {...params}
            variant="outlined"
            onChange={parseTimeHandler}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <AccessTimeIcon />
                </InputAdornment>
              ),
              endAdornment: <Fragment></Fragment>,
            }}
            onKeyDown={(e) => {
              if (e.key == "Enter") {
                handleChangeTime(null, e.target.value, menuList);
                setParsedTime(timeValue);
              }
            }}
            onBlur={(e) => {
              handleChangeTime(null, e.target.value, menuList);
              setParsedTime(timeValue);
            }}
          />
        )}
      />
      {twentyFourHour ? (
        <span>
          &nbsp;&nbsp;
          {getTranslation(currentLang, "surveyTaker:twentyFourHourTime")}
        </span>
      ) : (
        <span>
          &nbsp;&nbsp;
          {getTranslation(currentLang, "surveyTaker:twelveHourTime")}
        </span>
      )}
    </div>
  );
}

export default withStyles(styles)(TimeRangeDropdown);
